import InputSearch from '../components/InputSearch';
import AboutSection from '../pages/homepage/components/SectionAbout';
import { APP_ROUTES } from './app-routes';
import { OPTION_MENU } from './menu';

const { DASHBOARD, MANAGE_VENUES, INBOX, TRANSACTIONS, ABOUT_US } = APP_ROUTES;

export const VENUE_NAVBAR_MENU = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    active: true,
    route: DASHBOARD,
    roles: [],
  },
  {
    id: 'manage_venues',
    name: 'Manage Venues',
    active: false,
    route: MANAGE_VENUES,
    roles: [],
  },
  {
    id: 'inbox',
    name: 'Inbox',
    active: false,
    route: INBOX,
    roles: [],
  },
  // {
  //   id: 'transactions',
  //   name: 'Transactions',
  //   active: false,
  //   route: TRANSACTIONS,
  //   roles: [],
  // },
  {
    id: 'faqs',
    name: 'FAQs',
    active: true,
    onClick: () => window.open('https://fayven.com/faq/', '_blank'),
  },
  {
    id: 'about_us',
    name: 'About Us',
    active: true,
    // route: ABOUT_US,
    onClick: () => window.open('https://fayven.com/about/', '_blank'),
  },
];

export const VENDOR_NAVBAR_MENU = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    active: true,
    route: DASHBOARD,
    roles: [],
  },
  {
    id: 'faqs',
    name: 'FAQs',
    active: true,
    onClick: () => window.open('https://fayven.com/faq/', '_blank'),
  },
  {
    id: 'about_us',
    name: 'About Us',
    active: true,
    // route: ABOUT_US,
    onClick: () => window.open('https://fayven.com/about/', '_blank'),
  },
];

export const ADMIN_NAVBAR_MENU = [
  {
    id: 'dashboard',
    name: 'Dashboard',
    active: true,
    route: DASHBOARD,
    roles: [],
  },
  {
    id: 'manage_transactions',
    name: 'Transactions',
    active: false,
    route: TRANSACTIONS,
    roles: [],
  },
];
